export default __webpack_public_path__ + "static/media/spinner.1a24ca5a.svg";